import { SlackChannel } from '@mode/shared/contract-common';
import { RawScheduleOwner, RawSlackMembership, ScheduleSlackFacade, SlackApp } from '@mode/shared/schedules/contract';
import { Injectable } from '@angular/core';

@Injectable()
export class ScheduleSlackFacadeService extends ScheduleSlackFacade {
  public slackAppUrl = '';
  public slackAppTeamName = '';
  public slackChannels: Array<SlackChannel> | [] = [];

  protected _ModeCollection = {} as any;
  protected _rawScheduleOwner = {} as unknown as RawScheduleOwner;

  public initialize(rawScheduleOwner: RawScheduleOwner, ModeCollection: any) {
    this._rawScheduleOwner = rawScheduleOwner;
    this._ModeCollection = ModeCollection;
  }

  public getSlackChannel(membership: RawSlackMembership): SlackChannel {
    const foundChannel = this.slackChannels.find((channel: SlackChannel) => channel.name === membership.channel);

    return (
      foundChannel ?? {
        channelName: membership.channelName,
        name: membership.channel,
        id: membership.channel_id,
        type: membership.channel_type,
      }
    );
  }

  public tryToInitialize(): Promise<boolean> {
    return this.load()
      .then(() => true)
      .catch((e) => {
        if (e.message === 'Model account has no slackApp as slackApp') {
          return false;
        }
        throw e;
      });
  }

  private load() {
    return this.getSlackApp()
      .then((slackApp) => {
        this.slackAppUrl = slackApp.team_url;
        this.slackAppTeamName = slackApp.team_name;
        return slackApp.channels();
      })
      .then(this._ModeCollection.elements)
      .then((rawChannels) => {
        this.slackChannels = rawChannels.map(
          ({ id, channelName, name }) =>
            ({
              id,
              channelName,
              name,
            }) as SlackChannel
        );
      });
  }

  protected getSlackApp(): Promise<SlackApp> {
    return this._rawScheduleOwner.slackApp();
  }

  protected get hasSlackApp() {
    return this._rawScheduleOwner?._resource?.hasLink('slack_app') ?? false;
  }
}
